if (typeof customElements.get('shipping-notice') === 'undefined') {

  class ShippingNotice extends HTMLElement {

    static get observedAttributes() {
      return ['data-cart-total-amount'];
    }

    constructor() {
      super();
    }

    connectedCallback() {
      this.render();
    }

    attributeChangedCallback(name, oldValue, newValue) {
      if (this.isConnected && oldValue !== newValue) {
        this.render();
      }
    }

    render() {

      const cartTotal = Number(
        this.getAttribute('data-cart-total-amount') || 0
      );

      const currencyRate =
        window.Shopify &&
        Shopify.currency &&
        Shopify.currency.rate
          ? Number(Shopify.currency.rate)
          : 1;

      /*
       * Chaque montant est déjà exprimé en centimes par Liquid.
       * On applique ensuite le taux de la devise sélectionnée.
       */
      const steps = [1, 2, 3]
        .map(index => {

          const threshold = Number(
            this.getAttribute(`data-threshold-${index}`) || 0
          );

          return {
            amount: Math.round(threshold * currencyRate),
            message:
              this.getAttribute(`data-message-${index}`) || ''
          };

        })
        .filter(step => step.amount > 0)
        .sort((a, b) => a.amount - b.amount);

      if (!steps.length) {
        this.innerHTML = '';
        return;
      }

      const maximumAmount = steps[steps.length - 1].amount;

      /*
       * La progression dépend du dernier palier.
       * Avec 129 € comme maximum :
       * 49 € = environ 38 %
       * 69 € = environ 53 %
       * 129 € = 100 %
       */
      const progress = Math.min(
        Math.max((cartTotal / maximumAmount) * 100, 0),
        100
      );

      const nextStep = steps.find(step => cartTotal < step.amount);
      const allStepsReached = !nextStep;

      let message = this.getAttribute('data-success-message') || '';

      /*
       * Le texte affiché est celui du prochain palier.
       */
      if (nextStep) {

        const remainingAmount = Math.max(
          nextStep.amount - cartTotal,
          0
        );

        message = nextStep.message.replace(
          /\{\{\s*remaining_amount\s*\}\}/g,
          this.formatMoney(
            remainingAmount,
            KROWN.settings.shop_money_format
          )
        );

      }

      const markers = steps
        .map((step, index) => {

          const markerPosition = Math.min(
            (step.amount / maximumAmount) * 100,
            100
          );

          const isReached = cartTotal >= step.amount;
          const isLast = index === steps.length - 1;

          return `
            <span
              class="
                shipping-rewards__marker
                ${isReached ? 'is-reached' : ''}
                ${isLast ? 'is-last' : ''}
              "
              style="left: ${markerPosition}%"
              aria-hidden="true"
            ></span>
          `;

        })
        .join('');

      this.innerHTML = `
        <div class="
          shipping-rewards
          ${allStepsReached ? 'is-complete' : ''}
        ">

          <div
            class="shipping-rewards__message"
            aria-live="polite"
          >
            ${message}
          </div>

          <div
            class="shipping-rewards__track"
            role="progressbar"
            aria-label="Progression des avantages"
            aria-valuemin="0"
            aria-valuemax="100"
            aria-valuenow="${Math.round(progress)}"
          >

            <span
              class="shipping-rewards__progress"
              style="width: ${progress}%"
            ></span>

            ${markers}

          </div>

        </div>
      `;

    }

    formatMoney(cents, format) {

      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }

      let value = '';

      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

      const formatString =
        format || '{{amount_with_comma_separator}} €';

      function formatWithDelimiters(
        number,
        precision,
        thousands,
        decimal
      ) {

        thousands = thousands || ',';
        decimal = decimal || '.';

        if (isNaN(number) || number === null) {
          return 0;
        }

        number = (number / 100).toFixed(precision);

        const parts = number.split('.');

        const amount = parts[0].replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          '$1' + thousands
        );

        const decimals = parts[1]
          ? decimal + parts[1]
          : '';

        return amount + decimals;

      }

      const match = formatString.match(placeholderRegex);

      if (!match) {
        return formatWithDelimiters(cents, 2, '.', ',');
      }

      switch (match[1]) {

        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;

        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;

        case 'amount_with_comma_separator':
          value = formatWithDelimiters(
            cents,
            2,
            '.',
            ','
          );
          break;

        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(
            cents,
            0,
            '.',
            ','
          );
          break;

        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(
            cents,
            0,
            ' '
          );
          break;

        case 'amount_with_apostrophe_separator':
          value = formatWithDelimiters(
            cents,
            2,
            "'"
          );
          break;

        default:
          value = formatWithDelimiters(
            cents,
            2,
            '.',
            ','
          );

      }

      return formatString.replace(
        placeholderRegex,
        value
      );

    }

  }

  customElements.define(
    'shipping-notice',
    ShippingNotice
  );

}